/* C7 — enhancement only: Shopify price-range inputs and faceting remain authoritative. */
(() => {
  if (window.__indiehousePricePresetsReady) return;
  window.__indiehousePricePresetsReady = true;

  function inputs(ui) {
    const native = ui.querySelector('price-range');
    if (!native) return null;
    const numbers = [...native.querySelectorAll('input[type="number"]')];
    const sliders = [...native.querySelectorAll('input[type="range"]')];
    return numbers.length === 2 && sliders.length === 2 ? { native, numbers, sliders } : null;
  }
  function markSelection(ui) {
    const c = inputs(ui);
    if (!c) return;
    const min = c.numbers[0].value === '' ? 0 : Number(c.numbers[0].value);
    const max = c.numbers[1].value === '' ? null : Number(c.numbers[1].value);
    const hasPrice = c.numbers.some(n => n.value !== '');
    const clear = ui.querySelector('[data-ih-price-clear]');
    if (clear) clear.hidden = !hasPrice;
    ui.querySelectorAll('[data-ih-price-preset]').forEach(chip => {
      const low = Number(chip.dataset.priceMin || 0);
      const high = chip.dataset.priceMax === '' ? null : Number(chip.dataset.priceMax);
      chip.setAttribute('aria-pressed', String(hasPrice && low === min && high === max));
    });
  }
  function choose(ui, minPrice, maxPrice) {
    const c = inputs(ui);
    if (!c) return;
    const ceiling = Number(ui.dataset.ihPriceMax) || Number(c.sliders[0].max) || 0;
    const low = Math.min(ceiling, Math.max(0, minPrice));
    const high = maxPrice === null ? null : Math.min(ceiling, Math.max(low, maxPrice));

    c.numbers[0].value = low === 0 ? '' : String(low);
    c.numbers[1].value = high == null || high >= ceiling ? '' : String(high);
    c.numbers[0].max = String(high === null ? ceiling : high);
    c.numbers[1].min = String(low);
    c.sliders[0].value = String(low);
    c.sliders[1].value = String(high === null ? ceiling : high);

    const range = c.native.querySelector('.range-group');
    if (range && ceiling > 0) {
      range.style.setProperty('--range-min', low / ceiling * 100 + '%');
      range.style.setProperty('--range-max', (high === null ? 100 : high / ceiling * 100) + '%');
    }
    for (const field of c.numbers) {
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    }
    markSelection(ui);
  }
  document.addEventListener('click', event => {
    const el = event.target instanceof Element ? event.target : event.target?.parentElement;
    const target = el?.closest('[data-ih-price-preset],[data-ih-price-clear]');
    const ui = target?.closest('[data-ih-price-ui]');
    if (!ui) return;
    event.preventDefault();
    if (target.hasAttribute('data-ih-price-clear')) choose(ui, 0, null);
    else choose(ui, Number(target.dataset.priceMin || 0),
      target.dataset.priceMax === '' ? null : Number(target.dataset.priceMax));
  }, true);

  document.addEventListener('input', event => {
    const ui = event.target?.closest?.('[data-ih-price-ui]');
    if (ui) markSelection(ui);
  });
  document.addEventListener('change', event => {
    const ui = event.target?.closest?.('[data-ih-price-ui]');
    if (ui) markSelection(ui);
  });
  const initialize = () => document.querySelectorAll('[data-ih-price-ui]').forEach(markSelection);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once:true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
